import React, { useState } from 'react'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { collection, addDoc, serverTimestamp, doc, getDoc,  } from "firebase/firestore";
import { useNavigate,  useParams } from "react-router-dom"
import { auth, db, storage } from '../../../firebase'



const Edit = ({inputs, title}) => {

  // const [file, setFile ] = useState("")
  const [ data, setData ] = useState({})
  // const [ perc, setPerc ] = useState(null)
  const [ isloading, setIsloading ] = useState(false)

  const [charges, setCharges] = useState([])

  const navigate = useNavigate();

//   const params = useParams()

  const {chargeId} = useParams()

//   console.log("charge Id: ", chargeId)


  const Spinner = () => {
    return(
      <span className='spinner-container'>
          <span className='loading-spinner'></span>
      </span>
    )
  }

  const getCharge = async() => {

    const docRef = doc(db, "charges", chargeId);

    const docSnap = await getDoc(docRef);

        
    if (docSnap.exists()) {

      setCharges(docSnap.data() )

    } else {
      
      console.log("No such document!");
    }


}

console.log('charges: ',charges)



 

useEffect(()=>{

  getCharge()

}, [])


  


  const handleInput = (e) =>{
    const id = e.target.id;
    const value = e.target.value;

    setData({...charges, [id]:charges.id})
  }

  
  const handleAdd = async(e) => {

    e.preventDefault()
    setIsloading(true)

    try{
       
       
       await addDoc(collection(db, "charges"), {
        ...data, charges : 'visaCharges',
        timeStamp: serverTimestamp(),
        

      });
      
      setIsloading(false)

      navigate('/charges')
      
      
    }catch (err) {
      console.log(err);
    } 

  }
console.log(charges)
  return (
    <div className="new">
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
        <div className='topLeft'><h1>{title}</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/charges"
            >
              Charges List
            </Link>
            <Typography color="green">Add Charges</Typography>
          </Breadcrumbs>
          </div>
        </div>
        
        <div className='bottom'>
        
          <div className='right'>
            <form onSubmit={handleAdd}>

                <div className='formInput' >
                    <label>Company Introduction:</label>
                    <input type="text" placeholder="$15" value={charges.companyIntroduction} onChange={handleInput} id="companyIntroduction" required/>
                </div>

                <div className='formInput' >
                    <label>Self Introduction:</label>
                    <input type="text" placeholder="$15" value={charges.selfIntroduction}  onChange={handleInput} id="selfIntroduction" required/>
                 </div>

                 <div className='formInput' >
                    <label>Leave Approval:</label>
                    <input type="text" placeholder="$15" value={charges.leaveApproval}  onChange={handleInput} id="leaveApproval" required/>
                </div>

                <div className='formInput' >
                    <label>Employment Letter:</label>
                    <input type="text" placeholder="$15" value={charges.employmentLetter}  onChange={handleInput} id="employmentLetter" required/>
                 </div>

                 <div className='formInput' >
                    <label>Visa Processing Fee:</label>
                    <input type="text" placeholder="$15" value={charges.visaProcessingFee}  onChange={handleInput} id="visaProcessingFee" required/>
                </div>

             <button type='submit'>
              {isloading && <span>...</span>}
              {isloading ? <span>loading</span> : <span>Submit</span>}

              
             </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Edit
